import { Component } from "react";
import {
    View,
    TouchableOpacity,
    Image,
    Dimensions,
    ScrollView,
} from "react-native";

import { WHITE } from "react-native-material-color";
// import ActionSheet from 'react-native-actionsheet';

import * as Styles from "../utils/Styles";
import * as AppStyles from "../utils/appStyles";
import * as Commons from "../utils/Commons";
import { STRINGS } from "../utils/Strings";
import Text from "../components/Text";
import NotificationSettings from "./NotificationsSettings";
let height = Dimensions.get("window").height;
let width = Commons.getWidth();
let marginTop = 230;
let styles = {};
let brandPos = 1;
let brandFlag = 1;
let isMobile = false;
let scale = 1;
const closeIcon = require("../images/productDetails/closeIcon.png");
const cartIcon = require("../images/productDetails/cartIcon.png");
const backIcon = require("../images/Notifications/backArrow.png");
const settingsIcon = require("../images/Notifications/settings.png");
const orderConfirmationIcoin = require("../images/Notifications/orderConfirmation.png");
const itemsBackInStockIcon = require("../images/Notifications/itemsInStock.png");
const limitedBonusOffers = require("../images/Notifications/limitedBonus.png");
const isNewIcon = require("../images/Notifications/isNewIcon.png");


class Notifications extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isSettings: false,
            isOther: false,
        };
    }
    Pressables = {};

    async componentDidMount() {
        this.loadData();
    }


    loadData = async () => {
        // loaderHandler.showLoader(STRINGS.loading, this);

        // loaderHandler.hideLoader();
    }

    renderHeader = () => {

        const { showProductsDetails } = this.props;
        return (
            <View style={{
                flexDirection: 'row',
                alignItems: 'center', padding: 20, alignSelf: "stretch", justifyContent: "space-between",
                paddingVertical: isMobile ? 20 : 30,
            }}>
                {
                    isMobile && <TouchableOpacity onPress={() => { window.history.back() }}>
                        <Image source={backIcon} style={{
                            width: 18.667,
                            height: 16,
                            padding: 1,
                            resizeMode: "contain",
                            tintColor: Styles.appColor1
                        }} />
                    </TouchableOpacity>}
                {!isMobile && <View style={{ width: 18.667, height: 16 }}></View>}

                <Text style={[AppStyles.notificationText]}>
                    {STRINGS.app_notifications}
                </Text>

                <TouchableOpacity onPress={() => { this.setState({ isSettings: true }) }}>
                    <Image source={settingsIcon} style={{ width: 21, height: 20, tintColor: Styles.appColor1 }}></Image>
                </TouchableOpacity>
            </View>
        )
    }



    renderMobile() {
        scale = width / 420;
        if (this.state.isSettings) {
            return <NotificationSettings self={this}
                isSettings={(show) => { this.setState({ isSettings: show, }) }} />;
        }
        return (
            <View style={styles.container}>
                {/* {Commons.renderAppHeader({}, this)} */}
                {this.renderHeader()}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width, }}>
                        {Commons.loadFonts(this, false)}
                        {Styles.renderVSeparator(0)}
                        {this.renderPart1Mobile()}
                    </View>
                </ScrollView>
                {this.state.isOther && Commons.renderOtherView(this, this.state.isOther)}
                {Commons.renderAppFooter({}, this, '', '', '', '#52C0EE', true)}
            </View >
        );
    }

    render() {
        Commons.resizeHandle(window, this, () => {
            width = this.width;
            height = this.height;
        });
        width = this.props.width ? this.props.width : Dimensions.get("window").width;
        isMobile = Commons.isMobile();
        if (isMobile) {
            styles = this.styles();
            return this.renderMobile();
        }
        styles = this.styles();
        if (this.state.isSettings) {
            return <NotificationSettings self={this} width={width}
                isSettings={(show) => { this.setState({ isSettings: show, }) }} />;
        }
        return (
            <View style={styles.container}>
                {/* {Commons.renderAppHeader({}, this)} */}
                {this.renderHeader()}
                <ScrollView
                    ref={ref => this.mainScrollView = ref}
                    scrollEventThrottle={200} showsVerticalScrollIndicator={false} onScroll={(e) => Commons.onHeaderScroll(e, this)}>
                    <View style={{ width, }}>
                        {Styles.renderVSeparator(0)}
                        {this.renderPart1Mobile()}
                    </View>
                </ScrollView>
                {this.state.isOther && Commons.renderOtherView(this, this.state.isOther)}
            </View >
        );
    }



    renderPart1 = () => {
    }



    renderPart1Mobile = () => {
        const NotificationViews = [
            { id: 1, title: STRINGS.order_confirmation, description: 'Your order #4829 has been received and is being processed.', icon: orderConfirmationIcoin, isNew: true, isNewIcon: isNewIcon },
            { id: 2, title: STRINGS.item_back_in_stock, description: STRINGS.item_back_in_stock, icon: itemsBackInStockIcon, isNew: false, isNewIcon: isNewIcon },
            { id: 3, title: STRINGS.limited_time_bonus_offers, description: STRINGS.limited_time_bonus_offers, icon: limitedBonusOffers, isNew: false, isNewIcon: isNewIcon },
        ];
        return (
            <View style={{ flex: 1, alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column', }}>
                {NotificationViews.map((item, index) => (
                    <TouchableOpacity key={index}
                        style={{ width: '100%', padding: 20, flexDirection: 'row', alignItems: 'center', borderBottomWidth: 1, borderBottomColor: '#ccc' }}
                        onPress={() => { }}>
                        {item.isNew && <Image source={item.isNewIcon} style={{ width: 10, height: 10, marginRight: 10 }} />}
                        {!item.isNew && <View style={{ width: 10, height: 10, marginRight: 10 }} />}
                        <Image source={item.icon} style={{ width: 47, height: 47, marginRight: 10 }} />
                        <View style={{ flex: 1 }}>
                            <Text style={[AppStyles.mainNotificationText]}>{item.title}</Text>
                            <Text style={[AppStyles.mainNotificationDescText]}>{item.description}</Text>
                            {item.isNew && (<Text style={[AppStyles.mainNotificationDescText]}>Today, 13:01</Text>)}
                        </View>
                    </TouchableOpacity>
                ))}
            </View>
        )
    }




    styles = () => ({
        container: {
            flex: 1,
            width: width,
            alignItems: "center",
            backgroundColor: WHITE
        },
        image: {
            flex: 1,
            resizeMode: 'contain',
            justifyContent: 'center',
            width,
            height: 590,
        }
    });
}



export default Notifications;
